import { useState, useEffect } from "react";
import "./GoogleDrivePicker.css";
import Modal from "../shared/Modal";
import { MSDrive } from "winslow-core";
import { selectUser } from "../../redux/features/appData";
import { useSelector } from "react-redux";
import { apiGetGoogleDrives } from "../../services/DriveService";

type GoogleDrivePickerProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelected: (gDrive: MSDrive | null) => void;
};

export const GoogleDrivePicker = ({
  isOpen,
  onClose,
  onSelected,
}: GoogleDrivePickerProps) => {
  const storeUser = useSelector(selectUser);

  const [googleDrives, setGoogleDrives] = useState<MSDrive[] | null>(null);

  useEffect(() => {
    if (!googleDrives && storeUser) {
      (async () => {
        const drives = await apiGetGoogleDrives(storeUser.id);
        setGoogleDrives(drives);
        if (!drives || drives.length === 0) {
          onSelected(null);
        }
      })();
    }
  }, []);

  console.log("[GoogleDrivePicker] sites: ", googleDrives);

  return (
    <Modal
      isOpen={isOpen}
      style={null}
      onClose={onClose}
      canClose={false}
      allowClickout={true}>
      <div className="google-drive-picker-container">
        {!googleDrives && (
          <div className="google-drive-loading">
            <div className="google-drive-picker-logo">
              <img src="/icons/googledrive.png" alt="" />
            </div>
            Loading Google drives...
          </div>
        )}
        {googleDrives && (
          <div className="google-drive-picker-header">
            <div className="google-drive-picker-title">Pick a Google Drive</div>
            <div className="google-drive-picker-buttons">
              <img className="icon-close" onClick={onClose} alt="" />
            </div>
          </div>
        )}

        <div className="google-drive-picker-body">
          {googleDrives && (
            <div
              key={"sp-drive-my-drive"}
              className="google-drive-picker-drive"
              onClick={() => onSelected(null)}>
              <div className="google-drive-picker-folder">
                <img src="/icons/googledrive.png" alt="" />
              </div>
              <div className="google-drive-picker-site-drive-name">
                My Drive
              </div>
            </div>
          )}
          {googleDrives &&
            googleDrives.map((gDrive: MSDrive) => {
              return (
                <div
                  key={"sp-drive-" + gDrive.id}
                  className="google-drive-picker-drive"
                  onClick={() => onSelected(gDrive)}>
                  <div className="google-drive-picker-folder">
                    <img src="/icons/googledrive.png" alt="" />
                  </div>
                  <div className="google-drive-picker-site-drive-name">
                    {gDrive.name}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
};
